import { MutationResponse, SuccessResponse } from "config";
import { gql } from "config/graphql";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

interface IUpdateNotificationData {
  updateNotification: SuccessResponse;
}

export const updateNotificationMutation: MutationResponse<string, IUpdateNotificationData> = async (
  notificationId: string
) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation UpdateNotification($input: UpdateNotificationInput!) {
      updateNotification(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IUpdateNotificationData>({
    variables: { input: { notificationId } },
    mutation,
  });
  return { data: assertDefined(data) };
};
